import axiosInstance from './axiosInstance';

const getPrivateSubcategories = async ({ token, categoryId }) => {
  try {
    const response = await axiosInstance.post(
      '/privatesubcategories',
      categoryId ? { categoryId } : {},
      {
        headers: {
          Authorization: token,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error('Error posting data: ' + error.message);
  }
};

export { getPrivateSubcategories };
